import Browser from "./Browser";
import Desk from "./Desk";
import background from "./editor.png";
import Icon from "./Icon";

const Simple = () => {

    const squareClass = 'w-20 h-20 lg:w-40 lg:h-40'
    const squareClassFake = squareClass+' -m-10 lg:-m-20'

    const browserContents = <>
    <div className='h-[150px] lg:h-[350px] bg-white flex items-center justify-center relative'>
        <div className={squareClass+' bg-teal-300 z-20 scrollSquare rounded-xl'}></div>
        <div className={squareClassFake+' border-2 border-dashed border-slate-200 -translate-x-[200px] rounded-xl absolute top-1/2 left-1/2'}></div>
        <div className={squareClassFake+' border-2 border-dashed border-slate-200 translate-x-[200px] rounded-xl absolute top-1/2 left-1/2 '}></div>
    </div>
  
        <div className='relative'>
            <img src={background} />
            <div className='map bottom-[50px] top-[90px] absolute w-[980px] right-[5px] hidden xl:block'>
                <div className='scrollLine h-full w-px bg-blue-500 absolute top-0 left-0 '>
                    <div className='w-[7px] h-[7px] absolute -top-[4px] -left-[3px] bg-blue-500'></div>
                    <div className='w-[5px] h-[5px] absolute top-[1px] -left-[2px] bg-blue-500 rotate-45'></div>
                    
                </div>
            </div>
     
        
    </div>
    </>

    return <section className=' p-5'>
        <div className='max-w-prose mx-auto text-center'>
            <Icon name='parallax' outer='bg-teal-50' inner='fill-teal-400' />
            <h2>Precisely build scroll based animations</h2>
            <p className='sub'>Build complex parallax animations with ease by assigning step values. Transitions will be silk-smooth, as Animator applies tweening based on the  element’s position in the viewport.</p>
        </div>
        <div className='p-5 lg:p-0 flex flex-col items-center'>
            <Desk>
                <div className='max-w-[1400px] rounded-3xl shadow-xl'>
                    <Browser>
                        {browserContents}
                    </Browser>
                </div>
            </Desk>

        </div>
    </section>
}

export default Simple